import React, { useEffect, useState } from "react";
import "./Accordion.scss";
import Icon from "../../Elements/Icon/Icon.tsx";
import { useParams } from "react-router-dom";
const Accordion = ({
  title = null,
  menuParams,
  children,
  profileUser = null,
  defaultShow = false,
  forceHide = false,
  setCategorySelected = null,
  categorySelected = null,
  isProfilePages = false,
}) => {
  const [show, setShow] = useState(defaultShow ? defaultShow : false);
  const [activeTitle, setActiveTitle] = useState(false);
  const params = useParams();
  useEffect(() => {
    if (profileUser) {
      if (params.profileCategory && params.profileCategory === menuParams) {
        //setShow(true);
        setActiveTitle(true);
      }
    }
  }, [profileUser, params, menuParams]);
  const handleClickShow = () => {
    if (!isProfilePages) {
      setShow((prev) => !prev);
    } else {
      if (categorySelected === menuParams) {
        setCategorySelected(null);
      } else {
        setCategorySelected(menuParams);
      }
    }
  };

  return (
    <div className="accordion-main">
      <div
        className={
          activeTitle ? "accordion-title title-active" : "accordion-title"
        }
        onClick={() => handleClickShow()}
      >
        {title}
        <Icon
          iconClass={`title-arrow ${forceHide ? "down" : show ? "up" : "down"}`}
          name="arrow-up"
        />
      </div>
      <div
        className={`accordion-content ${
          forceHide ? "non-active" : !show ? "non-active" : ""
        }`}
      >
        {children}
      </div>
    </div>
  );
};

export default Accordion;
